const DescSortIcon = ({ height, width, color }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 -960 960 960" width={width} fill={color}>
      <path d="M480-96 216-360l51-51 177 177v-630h72v630l177-177 51 51L480-96Z" />
    </svg>
  );
};

export default DescSortIcon;
